var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCadastro09(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 864 783.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill-rule:evenodd;fill:url(#Gradiente_sem_nome_6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    x1: 563.9,
    y1: -11624.84,
    x2: 1097.91,
    y2: -11289.78,
    gradientTransform: "matrix(1, 0, 0, -1, -267.64, -11128.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c92795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#a62bb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#892eca"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1097.03,
    y: 147.69,
    width: 1605.6,
    height: 1716.33,
    transform: "translate(-37.52 1937.41) rotate(-53.58)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.54,437.68V548.11a79.15,79.15,0,0,0,40.9,69.22L373,724.69a78,78,0,0,0,75.45,0L644.93,617.33a79.16,79.16,0,0,0,40.91-69.22V437.68L448.41,567.43a77.91,77.91,0,0,1-75.45,0ZM373,58,41.57,238.81c-27.09,14.93-27.09,54.29,0,69.22L373,488.8a77.91,77.91,0,0,0,75.45,0L764.46,316.21V548.52a39.27,39.27,0,0,0,78.53,0V296.58A39.48,39.48,0,0,0,822.54,262L448.31,58A80,80,0,0,0,373,58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCadastro09);
export default __webpack_public_path__ + "static/media/icon_cadastro-09.e5d46577585a6c44e1a8d1fee2e96ee7.svg";
export { ForwardRef as ReactComponent };